module.exports = __webpack_public_path__ + "img/le-lodge-park-megeve_0.a8ad6b98.jpg";